import React from 'react'
import ContactusComponent from '../components/ContactusComponent'

const ContactUs = () => {
  return (
    <div>
      <ContactusComponent />
    </div>
  )
}

export default ContactUs
